module.exports = __webpack_public_path__ + "img/icon-Cal-ICS.39762f65.png";